<div class="zoom-button-wrapper">
    <ion-button (click)="zoomIn()" class="ion-no-padding ion-color ion-color-light" shape="round" size="small">
        <ion-icon color="dark" slot="icon-only" src="/assets/icons/ui/zoom-in.svg" />
    </ion-button>
    <ion-button (click)="zoomOut()" class="ion-no-padding ion-color ion-color-light" shape="round" size="small">
        <ion-icon color="dark" slot="icon-only" src="/assets/icons/ui/zoom-out.svg" />
    </ion-button>
</div>
